<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>连通用友</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤" clearable
                    v-model="filterText">
          </el-input>
          <el-tree
            style="height: 900px;"
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            show-checkbox
            ref="tree"
            @check="checkShop">
          </el-tree>
        </div>
      </div>

      <div style="rgb(222,222,222);width: 80%;height: 600px;">
        <el-button size="mini" type="primary" plain  @click="connectionYonYou">接通用友</el-button>
        <el-date-picker
          v-model="baseRequest.selectDate"
          type="daterange"
          range-separator="至"
          size="mini"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectKpiData"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button size="mini" type="primary" plain  @click="selectSubmitYonyouData">查询</el-button>
        <el-button size="mini" type="primary" plain  @click="yijiantijiao">发送</el-button>
          <el-table :data="yonyouDataList" fit border stripe="stripe" height="600px"
                    :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}">
            <el-table-column
              align="center"
              prop="date"
              label="制表日期" width="100">
            </el-table-column>
            <el-table-column
              align="center"
              prop="docType"
              label="凭证类别" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="docCode"
              label="凭证编号" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="summary"
              label="摘要" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="accountCode"
              label="科目编码" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="accountName"
              label="科目" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="currency"
              label="币种" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="dCDirection"
              :formatter="stateFormatter"
              label="借贷方向" >
            </el-table-column>
            <el-table-column
              align="center"
              prop="money"
              label="本币" >
            </el-table-column>
          </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data(){
    return{
      orgId:'',
      orgLevel:'',
      authorities:'',
      orgList: [],
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      orderList:[],
      baseRequest:{
        selectDate:'',
        startDate:'',
        endDate:'',
        orgIds:[],
        shopId:'',
        sendYonyouDatas:[]
      },
      yonyouDataList:[],
      stateText:[
        {dCDirection:'00', name:'借方'},
        {dCDirection:'01', name:'贷方'}
      ],
    }
  },
  methods:{
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    async yijiantijiao(){
      this.baseRequest.sendYonyouDatas = this.yonyouDataList;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/send/yonyouData`,this.baseRequest);
      if (res.code === 200){
        this.$message.success("提交成功！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    selectKpiData(){
      if (this.baseRequest.selectDate === null){
        this.baseRequest.startDate = '';
        this.baseRequest.endDate = '';
      } else {
        this.baseRequest.startDate = this.baseRequest.selectDate[0];
        this.baseRequest.endDate = this.baseRequest.selectDate[1];
      }
    },
    async connectionYonYou(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.get(`/getYonYouToken?orgId=` + this.baseRequest.shopId);
      if (res.code === 200){
        this.$message.success("连接成功！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      } else {
        this.$message.success("链接失败！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      }
    },
    //查询需要提交到用友的数据
    async selectSubmitYonyouData(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/yonyouData`,this.baseRequest);
      if (res.code === 200){
        this.$message.success("数据查询成功！")
        this.yonyouDataList = res.data;
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      } else {
        this.$message.success("数据查询失败！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      }
    },
    checkShop(node, list){
      if (list.checkedKeys.length > 1){
        this.$message.warning("请选择一个门店！");
        return;
      }
      this.baseRequest.shopId = list.checkedKeys[0];
      this.yonyouDataList = [];
    },
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.dcdirection === item.dCDirection) {
          value = item.name;
          break;
        }
      }
      return value;
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.loadOrg();
  }


}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #ffffff !important;
  .el-dialog__title{
    color: #ffffff;
  }
  .el-dialog__close{
    color: #ffffff !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/SubmitOrder.vue